export const SET_REQUEST = 'dashboard/guest/SET_REQUEST'
